import { render, staticRenderFns } from "./upContractPhotos.vue?vue&type=template&id=3a85f556&scoped=true"
import script from "./upContractPhotos.vue?vue&type=script&lang=js"
export * from "./upContractPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a85f556",
  null
  
)

export default component.exports